import { RestaurantTagList } from "../../Component/RestaurantTag/RestaurantTagList";
import { constants } from "../../Constants/constants";

export const RestaurantKeywordList = ({changeUrlQueryString}) => {
  return (
    <RestaurantTagList resource={constants.PATH.RESTAURANT_TAG.RESTAURANT_KEYWORD} resourceName="restaurant_keyword" changeUrlQueryString={changeUrlQueryString}/>
  )
};